import { AnalyticsContext } from '@carvana/eventable-clickstream';
import React, { useContext } from 'react';
import styled from 'styled-components';
import Cart from '|/app/header/cart';
import * as sc from '|/app/header/header.styles';
import ImpersonationBanner from '|/app/header/impersonation-baner';
import LockTimer from '|/app/header/lock-timer';
import MobileNavigationRailContext from '|/app/mobile-navigaton-rail-context';
import { Summary } from '|/app/services';
import theme from '|/components/base/theme';
import ListIcon from '|/icons/ListIcon.svg';
import { SupportContactButton, SupportMFE } from './supportcontact';
import SupportContactMfeContext from '../support-contact-mfe-context';
import usePurchaseHeaderEvent from '../use-purchase-header-event';

const DesktopOnly = styled.div`
  @media (max-width: ${theme.breakpoints.sm}) {
    display: none;
  }
`;

const MobileOnlyListIcon = styled(ListIcon)`
  @media (min-width: ${theme.breakpoints.sm}) {
    display: none;
  }
`;

const defaultProps = {
  hideHeader: false,
  orderSummary: null as null | Summary
};

const PurchaseHeader = ({ hideHeader, orderSummary } = defaultProps) => {
  const { setShowMobileNavigationRail } = useContext(
    MobileNavigationRailContext
  );
  const { trackEvent } = useContext(AnalyticsContext);
  const { isSupportMfeOpen, setIsSupportMfeOpen } = useContext(
    SupportContactMfeContext
  );
  usePurchaseHeaderEvent();
  if (hideHeader) return null;

  const isNativeWebview = /CarvanaNativeWebView/gi.test(navigator?.userAgent);

  const showNavigationMenu = () => {
    trackEvent('pp_clicked_list_icon');
    setShowMobileNavigationRail(value => !value);
  };

  const onLogoClick = () => {
    trackEvent('pp_clicked_logo_icon');
    window.location.href = '/';
  };

  return (
    <>
      <ImpersonationBanner />
      <sc.PurchaseHeaderWrapper>
        <sc.StyledPurchaseHeaderLogo
          tabIndex={0}
          onClick={onLogoClick}
          onKeyPress={(event: React.KeyboardEvent) => {
            if (event.key === 'Enter') {
              onLogoClick();
            }
          }}
          $isNativeWebview={isNativeWebview}
          data-analytics-id="pp_header_home"
        />
        <sc.StyledHorizontalCarvanaLogo
          tabIndex={0}
          onClick={onLogoClick}
          onKeyPress={(event: React.KeyboardEvent) => {
            if (event.key === 'Enter') {
              onLogoClick();
            }
          }}
          data-analytics-id="pp_header_home"
        />
        <sc.TimerCartWrapper>
          <DesktopOnly>
            <SupportContactButton setIsOpen={setIsSupportMfeOpen} />
          </DesktopOnly>
          <LockTimer orderSummary={orderSummary} isModal={false} />
          <Cart orderSummary={orderSummary} />
        </sc.TimerCartWrapper>
        <MobileOnlyListIcon
          onClick={showNavigationMenu}
          data-analytics-id="pp_header_mobile_list_icon"
        />
      </sc.PurchaseHeaderWrapper>
      <SupportMFE
        isOpen={isSupportMfeOpen}
        closeAction={() => setIsSupportMfeOpen(false)}
        closeMobileNavMenu={() => setShowMobileNavigationRail(false)}
      />
    </>
  );
};

export default PurchaseHeader;
